import React from "react";
import QRCode from "qrcode";

class QRCodeGenerator extends React.Component {
  componentDidMount() {
    this.generateQRCode();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.address !== this.props.address) {
      this.generateQRCode();
    }
  }

  generateQRCode = () => {
    const { address, id } = this.props;
    QRCode.toCanvas(
      document.getElementById(id),
      address,
      { width: "200px" },
      (error) => {
        if (error) {
          console.error(error);
        }
      },
    );
  };

  render() {
    const { id } = this.props;
    return <canvas id={id} />;
  }
}

export default QRCodeGenerator;
